import React from "react"
import StyledBannerImage from "../StyledBannerImage";
import CustomButton from "../CustomButton";

function selectGrandient(gradient) {
  switch (gradient) {
    case "hard":
      return "gl-home-banner__container--hard"
    case "med":
      return "gl-home-banner__container--medium"
    case "soft":
      return "gl-home-banner__container--soft"
    default:
      return ""
  }
}

const CustomImg = ({src}) => {
  return <img src={src} alt='' className={selectGrandient()}/>
}

const openLink = (link) => {
  window.open(link, '_blank')
}

const HomeBanner = ({ url, title, text, gradient, link, mobileView }) => {
  const classes = [
    "gl-home-banner__image",
    selectGrandient(gradient)
  ].join(" ")

  const hasContent = title || text || link

  return (
    <>
      {mobileView ? (
        <div>
          <CustomImg src={url} />
        </div>
      ) : (
        <div className="gl-home-banner__container">
          <StyledBannerImage className={classes} src={url} alt="" />
          {hasContent && (
            <div className="gl-home-banner__content">
              {title && <p className="gl-home-banner__title">{title}</p>}
              {text && (
                <div
                  className="gl-home-banner__text"
                  dangerouslySetInnerHTML={{ __html: text }}
                />
              )}
              {link && (
                <CustomButton
                  onClick={()=>openLink(link)}
                  tight
                  rel="noopener noreferrer"
                  className="gl-home-banner__cta"
                >
                  Ver mais
                </CustomButton>
              )}
            </div>
          )}
        </div>
      )}
    </>
  )
}

export default HomeBanner
